import { Phone, MessageCircle, MessageSquare, Mail, StickyNote, ArrowRightLeft } from 'lucide-react';

export const INTERACTION_TYPES = [
  { id: 'call', label: 'Llamada', icon: Phone, color: 'text-sky-600', bg: 'bg-sky-50' },
  { id: 'whatsapp', label: 'WhatsApp', icon: MessageCircle, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { id: 'sms', label: 'SMS', icon: MessageSquare, color: 'text-violet-600', bg: 'bg-violet-50' },
  { id: 'email', label: 'Email', icon: Mail, color: 'text-amber-600', bg: 'bg-amber-50' },
  { id: 'note', label: 'Nota', icon: StickyNote, color: 'text-slate-600', bg: 'bg-slate-100' },
];

export const typeMeta = (id) => INTERACTION_TYPES.find((t) => t.id === id) || { id, label: 'Cambio de estado', icon: ArrowRightLeft, color: 'text-slate-500', bg: 'bg-slate-100' };

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');
export const fmtDate = (iso) => (iso ? new Date(`${iso}T12:00:00`).toLocaleDateString('es-AR') : '');
export const fmtMoney = (n) => (n == null ? '-' : `$${Number(n).toLocaleString('es-AR')}`);

export const toLocalInputValue = (date = new Date()) => {
  const d = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return d.toISOString().slice(0, 16);
};

export const StateBadge = ({ state, className = '' }) => {
  if (!state) return null;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-wide whitespace-nowrap ${className}`}
      style={{ backgroundColor: `${state.color}22`, color: state.color }}
      data-testid="crm-state-badge"
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: state.color }} />
      {state.name}
    </span>
  );
};
